module.exports = __webpack_public_path__ + "media/images/CO_facebook-abe294f2.svg";